import axiosInstance from "../utils/axios";

export interface FAQTranslation {
  question: string;
  answer: string;
}

export interface FAQItem {
  _id: string;
  en: FAQTranslation;
  ar: FAQTranslation;
  createdBy: {
    _id: string;
    full_name: string;
  };
  createdAt: string;
  updatedAt: string;
}

export interface FAQResponse {
  status: number;
  message: string;
  data: FAQItem[];
}

export const getFaqsAPI = async (): Promise<FAQResponse> => {
  try {
    const response = await axiosInstance.get(`/api/user/faq/list`);
    return response.data;
  } catch (error: any) {
    console.error("Error fetching FAQs:", error);
    throw new Error(error.response?.data?.message || "Failed to fetch FAQs");
  }
};
